const question = {
    minimum: { point: [1] },
    medium: { point: [2] },
    maximum: { point: [3] },
};

export default question;
